export const GAMECDK_CREATE_QRCODE = 'GAMECDK_CREATE_QRCODE';
export const GAMECDK_CREATE_QRCODE_SUCCESS = 'GAMECDK_CREATE_QRCODE_SUCCESS';
export const GAMECDK_POLLS = 'GAMECDK_POLLS';
export const GAMECDK_POLL_SUCCESS = 'GAMECDK_POLL_SUCCESS';

export const GAMECDK_SET_VISIBLE = 'GAMECDK_SET_VISIBLE';
export const GAMECDK_CODE_VISIBLE = 'GAMECDK_CODE_VISIBLE';

export const GAMECDK_CODE_GET_DESC = 'GAMECDK_CODE_GET_DESC';
export const GAMECDK_CODE_GET_DESC_SUCCESS = 'GAMECDK_CODE_GET_DESC_SUCCESS';
